<template>
    <div class="invalid-info">
        <div class="invalid-header">
            <img src="@/assets/warning-icon.png" alt="warning" class="warning-icon">
            <h1>We couldn't find a matching order.</h1>
        </div>
        <p>
            Review the information you entered and try again. If you continue to experience issues, contact Customer Service at <a :href="`tel:${$config.customerSupportPhoneDial}`">{{ $config.customerSupportPhoneDisplay }}</a>.
        </p>
    </div>
</template>

<script>
export default {
    name: "InvalidInfo"
};
</script>

<style lang="scss" scoped>
.invalid-info {
    background: var(--Color-orange-dark-25, #FFF9F5);
    padding: 24px;
    margin-bottom: 24px;

    .invalid-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
            width: 20px;
            margin-right: 10px;
        }
    }

    h1 {
        color: var(--Color-orange-dark-400, #FF692E);
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-hs, 20px);
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 30px */
        letter-spacing: -0.2px;
        margin-bottom: 0;
    }

    p {
        color: #000;
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-tm, 16px);
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 24px */
        letter-spacing: -0.16px;
        padding-left: 30px; 

        a {
            color: var(--Color-blue-bright-500, #0691EF);
            font-family: var(--font-family-Inter, Inter);
            font-size: var(--font-size-tm, 16px);
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            letter-spacing: -0.16px;
            text-decoration: none;
        }
    }
}
</style>
